import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initNewRelic } from './newrelic';

initNewRelic();
// User identity is fed into New Relic from inside <Security> via the
// useNewRelicIdentity effect mounted in App.jsx \u2014 see frontend/src/auth.js
// (useCurrentUser) and frontend/src/nr-identity.jsx. We can't do it at module
// load time anymore: the access token doesn't exist until Okta hydrates the
// session, which happens after React mounts.

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
